import CustomTabs from 'components/CustomTabs';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SuperAdminView = () => {
  const [value, setValue] = useState();
  const location = useLocation();

  useEffect(() => {
    setValue(null);
    if (location?.pathname == '/Stores') {
      setValue('1');
    }
    if (location?.pathname == '/Admins') {
      setValue('2');
    }
    if (location?.pathname == '/Brackets') {
      setValue('3');
    }
    if (location?.pathname == '/Strengths') {
      setValue('4');
    }
  }, [location]);

  return (
    <>
      <CustomTabs value={value} setValue={setValue} />
    </>
  );
};

export default SuperAdminView;
